import { render, staticRenderFns } from "./commonReportTable.vue?vue&type=template&id=c9f6f436&scoped=true"
import script from "./commonReportTable.vue?vue&type=script&lang=js"
export * from "./commonReportTable.vue?vue&type=script&lang=js"
import style0 from "./commonReportTable.vue?vue&type=style&index=0&id=c9f6f436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f6f436",
  null
  
)

export default component.exports